module.exports = __webpack_public_path__ + "img/qrcode_bg.1b0b42cb.jpg";